import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import {
  CascadeOption,
  Rule
} from "@/lib/model/exambuilder/exam-component/rule";
import { cloneDeep } from "lodash-es";

interface AppendParams {
  dimensionBaseList: CascadeOption[];
  dimensionGroupList: CascadeOption[];
  paramsChoiceList: CascadeOption[];
  paramsMultiChoiceList: CascadeOption[];
  questionList: CascadeOption[];
  paramsIdList: CascadeOption[];
}

const paramsMap = {
  dimensionGroupName: {
    list: "dimensionGroupList",
    key: "dimensionGroupName"
  },
  dimensionKey: {
    list: "dimensionBaseList",
    key: "dimensionKey"
  },
  questionChoice: {
    list: "questionList",
    key: "questionId"
  },
  paramChoice: {
    list: "paramsChoiceList",
    key: "paramName"
  },
  paramMultiChoice: {
    list: "paramsMultiChoiceList",
    key: "paramName"
  },
  paramIdcard: {
    list: "paramsIdList",
    key: "paramName"
  }
};

@Module({
  name: "Rules",
  store,
  dynamic: true,
  namespaced: true
})
class RuleStore extends VuexModule {
  allAttrs: CascadeOption[] = [];
  attrRelations: any = {};
  attrEnums: any = {};
  attrLevels: any = {};

  @Action({ commit: "SET_ALL_ATTRS" })
  async getAllAttrs(params: AppendParams) {
    const resp = await Rule.get();
    return {
      rules: resp,
      params
    };
  }

  @Mutation
  SET_ALL_ATTRS(data: { rules: Rule[]; params: AppendParams }) {
    const { rules, params } = data;

    const specialFieldParams = (
      list: CascadeOption[],
      key: string,
      parent: Rule
    ) => {
      const newList = cloneDeep(list);
      for (let i = 0; i < newList.length; i++) {
        const item = newList[i];
        item.params = {
          [key]: item.value,
          attrKey: parent.attrDetail.attrKey
        };
        item.value = `${parent.attrDetail.attrKey}-${item.value}`;
        if (item.list) {
          this.attrLevels[item.value] = item.list;
        }
        this.attrRelations[item.value] = parent.attrDetail.relationshipList;
        this.attrEnums[item.value] = parent.attrDetail.enumList;
      }
      return newList;
    };
    const regenerate = (groupList: Rule[], deepth = 0) => {
      const result: CascadeOption[] = [];
      groupList.forEach((item, i) => {
        const hasConfigNeedList = item?.attrDetail?.configNeedList?.length;
        const resultItem: CascadeOption = {
          value: item?.attrDetail?.attrKey ?? `${deepth}-${i}`,
          label: item?.attrDetail?.attrName ?? item.groupName,
          children: item.subList.length
            ? regenerate(item.subList, deepth + 1)
            : null
        };
        if (hasConfigNeedList) {
          let children: CascadeOption[] | null = null;
          for (const child of item.attrDetail.configNeedList) {
            if (Object.prototype.hasOwnProperty.call(paramsMap, child)) {
              if (!children) children = [];
              children.push(
                ...specialFieldParams(
                  params[paramsMap[child].list],
                  paramsMap[child].key,
                  item
                )
              );
            }
          }
          resultItem.children = children;
        }
        if (item?.attrDetail) {
          this.attrRelations[item.attrDetail.attrKey] =
            item.attrDetail.relationshipList;
          this.attrEnums[item.attrDetail.attrKey] = item.attrDetail.enumList;
        }
        result.push(resultItem);
      });
      return result;
    };
    const result = regenerate(rules);
    this.allAttrs = result;
  }
}

export const ruleStore = getModule(RuleStore);
